var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerFix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6701 9.2502L69.0429 60.1253C69.8945 61.6001 69.3891 63.4858 67.9144 64.3371C67.4457 64.6078 66.9138 64.7503 66.3727 64.7503H7.62728C5.92442 64.7503 4.54395 63.3699 4.54395 61.667C4.54395 61.1255 4.68643 60.594 4.95705 60.1253L34.3298 9.2502C35.1811 7.77544 37.0669 7.27018 38.5416 8.12161C39.0103 8.39223 39.3997 8.78147 39.6701 9.2502ZM33.9166 49.3336V55.5003H40.0833V49.3336H33.9166ZM33.9166 27.7502V43.167H40.0833V27.7502H33.9166Z",
    fill: "#12C0B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerFix);
export default __webpack_public_path__ + "static/media/server-fix.cba086425f454e96c6f3841cdb5dd13b.svg";
export { ForwardRef as ReactComponent };